export default "__VITE_ASSET__95247394__"